import { mockContacts } from '@/lib/demo-data/customer-communications-contacts';
import type { ContactApi } from '@/types/api/customer-detail';

/**
 * Demo-mode contact mutations. These mutate the module-level `mockContacts`
 * demo store in place so the contacts lists (per-customer and global, which
 * both derive from it) reflect the change once their queries are refetched.
 */

type ContactDemoFields = Partial<Omit<ContactApi, 'id' | 'customerId' | 'createdAt' | 'lastContact'>>;

function demotePrimaryContacts(customerId: string, exceptContactId: string): void {
  for (const contact of mockContacts) {
    if (contact.customerId === customerId && contact.id !== exceptContactId) {
      contact.isPrimary = false;
    }
  }
}

export function createContactDemo({
  customerId,
  contact,
}: {
  customerId: string;
  contact: ContactDemoFields;
}): ContactApi {
  const created: ContactApi = {
    ...contact,
    id: `CONT-DEMO-${Date.now()}`,
    customerId,
    createdAt: new Date().toISOString(),
    lastContact: null,
    isPrimary: contact.isPrimary ?? false,
  };

  mockContacts.push(created);
  if (created.isPrimary) {
    demotePrimaryContacts(customerId, created.id);
  }

  return created;
}

export function updateContactDemo({
  customerId,
  contactId,
  contact,
}: {
  customerId: string;
  contactId: string;
  contact: ContactDemoFields;
}): void {
  const existing = mockContacts.find((x) => x.id === contactId);
  if (!existing) return;

  Object.assign(existing, contact);
  if (contact.isPrimary) {
    demotePrimaryContacts(customerId, contactId);
  }
}

export function deleteContactDemo({ contactId }: { customerId: string; contactId: string }): void {
  const index = mockContacts.findIndex((x) => x.id === contactId);
  if (index !== -1) {
    mockContacts.splice(index, 1);
  }
}
